<fgb-page-header [pageTitle]="'polls.page.title'" [backButtonLink]="'/games'" class="short-footer" />

<div class="games-container">
  <div class="container d-flex flex-column">
    <a class="back-btn pt-lg-0 text-white d-none d-lg-flex flex-row align-items-center fw-bold" [routerLink]="'/games'"
      ><span class="material-symbols-outlined"> keyboard_arrow_left </span>
      <span class="font-size-14">{{ 'fantasy.back.to.game' | translate }}</span></a
    >
    <img class="banner-img mb-3" [src]="'games/poll-banner.jpg' | contentAssetImage" alt="polls banner" />
  </div>
</div>

<div class="games-page">
  <div class="games-content-area">
    <div class="container">
      <ng-container *inProductCode="[productCode.Free]"> <fgb-upgrade-banner></fgb-upgrade-banner></ng-container>
      <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
        <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions"> </fgbcl-game-polls-question-list>
      </ng-container>
    </div>
    <ng-template #shimmerEffect>
      <div class="card" aria-hidden="true" *ngFor="let i of [1, 2, 3]">
        <h6 class="card-title placeholder-glow text-center">
          <span class="question-shimmer-effect placeholder col-6"></span>
        </h6>
        <div class="answer-shimmer-effect-section">
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
        </div>
        <div class="answer-shimmer-effect-section mt-3">
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <p class="card-text placeholder-glow w-40 text-center">
            <span class="presentby-shimmer-effect placeholder col-7"></span>
          </p>
        </div>
      </div>
    </ng-template>
  </div>
</div>
